import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import DashboardPage from './pages/DashboardPage'
import NewResearchPage from './pages/NewResearchPage'
import RunDetailPage from './pages/RunDetailPage'
import QueryReviewPage from './pages/QueryReviewPage'
import TopicDetailPage from './pages/TopicDetailPage'
import AdminUsersPage from './pages/AdminUsersPage'
import GlobalSearchPage from './pages/GlobalSearchPage'
import AnalysisPage from './pages/AnalysisPage'
import DocumentsPage from './pages/DocumentsPage'
import RequireAdmin from './components/RequireAdmin'

function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/research/new" element={<NewResearchPage />} />
          <Route path="/search" element={<GlobalSearchPage />} />
          <Route path="/runs/:id" element={<RunDetailPage />} />
          <Route path="/runs/:id/review" element={<QueryReviewPage />} />
          <Route path="/runs/:id/topics/:iteration/:topicId" element={<TopicDetailPage />} />
          <Route path="/runs/:id/analysis" element={<AnalysisPage />} />
          <Route path="/runs/:id/documents" element={<DocumentsPage />} />
          <Route element={<RequireAdmin />}>
            <Route path="/admin/users" element={<AdminUsersPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<LoginPage />} />
    </Routes>
  )
}

export default App
